import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../utils/constants'; // Adjust this import path as needed
import { message } from 'antd';

interface FunctionalityBasedRouteProps {
  requiredFunctionality: string;
  children: React.ReactNode;
}

const FunctionalityBasedRoute: React.FC<FunctionalityBasedRouteProps> = ({ requiredFunctionality, children }) => {
  const navigate = useNavigate();
  const userFunctionalities = JSON.parse(localStorage.getItem('accessModules') || '{}');

  useEffect(() => {
    if (!userFunctionalities || !userFunctionalities[requiredFunctionality]) {
      if(userFunctionalities["cghsPortalLogin"]) {
        // navigate("/app/portal-login")
        navigate("/app/all-portals-login");
      }
      else {
        navigate("/app/patient-list")
        message.error("You must have the required functionality access")
      }
    }
  }, [userFunctionalities, requiredFunctionality, navigate]);

  if (!userFunctionalities || !userFunctionalities[requiredFunctionality]) {
    // Return null to prevent rendering anything while redirecting
    return null;
  }

  // If user has the required functionality, render the children
  return <>{children}</>;
};

export default FunctionalityBasedRoute;